import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();

  const logout = async () => {
    const sessionToken = localStorage.getItem('adminSessionToken');
    
    if (sessionToken) {
      try {
        await fetch('/.netlify/functions/auth', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            action: 'logout',
            sessionToken: sessionToken
          })
        });
      } catch (error) {
        console.error('Logout error:', error);
      }
    }
    
    localStorage.removeItem('adminSessionToken');
    localStorage.removeItem('adminUser');
    navigate('/admin');
  };

  return (
    <div className="admin-layout">
      <header className="admin-header">
        <h1>Admin Dashboard</h1>
        <button onClick={logout} className="logout-btn">Logout</button>
      </header>
      <main className="admin-main">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
